<template>
  <dashboard-component>
    <h1>About</h1>
  </dashboard-component>
</template>
<script>
</script>
<style>
</style>
